import React from 'react';
import { Check } from 'lucide-react';
import { colorPalettes } from '../../data/templateCustomizationSchemas';

export const ColorPalettePicker = ({ selectedPalette, onChange, palettes, title }) => {
  const items = palettes || colorPalettes;
  return (
    <div data-testid="color-palette-picker" className="space-y-4">
      <div>
        <h3 className="font-sans font-semibold text-stone-800 text-sm">{title || 'Fargepalett'}</h3>
        <p className="text-xs font-sans text-stone-500 mt-0.5">Choose the color theme that fits best</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {items.map((palette) => (
          <button
            key={palette.id}
            type="button"
            data-testid={`palette-option-${palette.id}`}
            onClick={() => onChange(palette.id)}
            className={`flex items-center gap-3 p-3.5 rounded-2xl border-2 transition-all text-left ${
              selectedPalette === palette.id
                ? 'border-primary bg-primary/5 ring-1 ring-primary/20'
                : 'border-stone-200 hover:border-stone-400 bg-white'
            }`}
          >
            {/* Color swatches */}
            <div className="flex -space-x-1.5 flex-shrink-0">
              {palette.colors.slice(0, 5).map((color, i) => (
                <div
                  key={i}
                  className="w-7 h-7 rounded-full border-2 border-white shadow-sm"
                  style={{ backgroundColor: color, zIndex: 5 - i }}
                />
              ))}
            </div>

            {/* Name + check */}
            <div className="flex-1 min-w-0">
              <p className={`text-sm font-sans font-medium truncate ${
                selectedPalette === palette.id ? 'text-primary' : 'text-stone-700'
              }`}>
                {palette.name}
              </p>
            </div>

            {selectedPalette === palette.id && (
              <div className="w-6 h-6 rounded-full bg-primary text-white flex items-center justify-center flex-shrink-0">
                <Check className="w-3.5 h-3.5" />
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};
